import QuickLinks from './QuickLinks';

export default QuickLinks;